export default __webpack_public_path__ + "static/media/confirm.0c6ce6f7.svg";